export default "__VITE_ASSET__CPMs12Iq__"